module.exports = __webpack_public_path__ + "img/Alke.f7d8276a.svg";